import Vue from 'vue'
import SvgIcon from './SvgIcon'

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
req.keys().forEach(req)
